import React from 'react';
import { IndexRoute, Route } from 'react-router';
import ActionOffers from './actionOffers';

export default (
  <Route path="propostas">
    <IndexRoute component={props => <ActionOffers {...props} />} />
  </Route>
);
